<template>
  <div>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model:loading="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ul class="coupon-list">
          <li v-for="item in list" :key="item" :title="item">
            <div class="flex flex-align-center title-box">
              <h2 class="flex-1">{{ item.PackageName }}</h2>
              <van-button
                color="#b57e48"
                :disabled="item.Remain === 0"
                round
                @click="share(item)"
              >
                分享
              </van-button>
            </div>
            <div>
              <p class="product flex-1">
                <span class="grey">产品：</span>
                {{ item.ProductName }}
              </p>
            </div>
            <div class="flex">
              <p class="flex-1">
                <span class="grey">截止日期：</span>
                <span v-if="item.Deadline">
                  {{ dateFormat(item.Deadline, 'yyyy-MM-dd hh:mm:ss') }}
                </span>
                <span v-else>永久有效</span>
              </p>
            </div>
            <div class="flex">
              <p class="flex-1">
                <span class="grey">数量：</span>
                <span>{{ item.Remain }}</span>
                /
                <span>{{ item.Quantity }}</span>
              </p>
              <a class="link" href="javascript:;" @click="showDetail(item)">
                查看生成明细>>
              </a>
            </div>
          </li>
        </ul>
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
  import store from '@/store'
  import { Toast } from 'vant'
  import { dateFormat } from '@/utils/filters'
  export default {
    props: {
      channel: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {
        list: [],
        page: {
          PageIndex: 1,
          PageSize: 10,
          Total: 0,
        },
        finished: false,
        loading: false,
        refreshing: false,
        dateFormat,
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      share(item) {
        this.$router.push({
          name: 'CouponShare',
          query: {
            packageId: item.PackageId,
          },
        })
      },
      showDetail(item) {
        this.$router.push({
          name: 'CouponDetail',
          query: { packageId: item.PackageId },
        })
      },
      async onRefresh() {
        this.page.PageIndex = 1
        this.list = []
        await this.fetchData()
        this.refreshing = false
      },
      onLoad() {
        setTimeout(() => {
          this.fetchData()
        }, 500)
      },
      async fetchData() {
        const params = {
          MarketingChannelId: this.channel.ChannelId,
          TenantId: (await store.getters['user/getTenant']).TenantId,
          PageIndex: this.page.PageIndex,
          PageSize: this.page.PageSize,
        }
        this.loading = true
        return store
          .dispatch('service/GetPackagePageListByMarketingChannelId', params)
          .then((data) => {
            const { Data } = data
            this.list.push(...Data.CurrentPage)
            this.page.Total = Data.Total
            this.loading = false
            if (this.list.length >= Data.Total || !Data.CurrentPage.length) {
              this.finished = true
            }
            this.page.PageIndex++
          })
          .catch((e) => {
            this.loading = false
            Toast(e.Message || '请求失败')
          })
      },
    },
  }
</script>
<style lang="scss" scoped></style>
